import { getUUID } from 'src/utils';
import EventManager from './eventManager';
const GETPRINTERS = 'getPrinters'; // 获取打印机列表
const GETPRINTERCONFIGBYPRINTERNAME = 'getPrinterConfig'; // 通过打印机名称获取打印机配置
const SETPRINTERCONFIG = 'setPrinterConfig'; // 设置打印机配置
const GETPRINRTASKSTATUS = 'print'; // 获取下发打印任务收到确认返回结果
const NOTIFYPRINTRESULT = 'notifyPrintResult'; // 获取打印结果返回
const GETTASKSTATUSBYTASKID = 'getTaskStatus'; // 指定taskID获取打印结果
const GETGLOBALCONFIG = 'getGlobalConfig'; // 获取全局配置
const SETGLOBALCONFIG = 'setGlobalConfig'; // 设置全局配置
const GETAGENTINFO = 'getAgentInfo'; // 获取客户端版本信息
const GETPRINTCONFIGNAMELIST = 'getPrintConfigNameList'; // 获取打印配置列表
const BUSINESSTYPE = 1; // 业务类型
const MESSAGETYPE = 6; // 新版消息类型
const CONFIGMESSAGETYPE = 5; // 打印配置消息类型
const OLDPRINTMESSAGETYPE = 3; // 旧版打印消息类型
const OLDGETCONFIGMESSAGETYPE = 5; // 旧版获取打印配置
const CAINIAO = 'CAINIAO'; // 菜鸟源
const PDD = 'PDD'; // 拼多多
const JD = 'JD'; // 京东
const BYTE = 'BYTE'; // 字节 todo 参考
const KUAISHOU = 'KUAISHOU'; // 快手
const VIP = 'VIP'; // 唯品会
const HUAWEI = 'HUAWEI'; // 华为商城
const PRINTRESULTNOTIFY = 'PrintResultNotify'; // 拼多多打印结果
const SUCCESS = 'success';
const FAILED = 'failed';
const NOTIFYPRINTERROR = 'notifyPrintError'; // 打印失败
const commConfig = {
    bussinessType: BUSINESSTYPE,
    messageType: MESSAGETYPE,
};
const DOLOGHOST = {
    daily: 'http://ibird-print.cainiao.test:7001',
    pre: 'https://ibird-platform-pre.cainiao.com',
    online: 'https://ibird-print.cainiao.com',
};
const COMMENDCONFIG = {
    getPrinters: () => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: GETPRINTERS,
            },
        };
    },
    getPrinterConfig: (printer = '') => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: GETPRINTERCONFIGBYPRINTERNAME,
                printer,
            },
        };
    },
    setPrinterConfig: (config = {}) => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: SETPRINTERCONFIG,
            },
            printer: config,
        };
    },
    printData: (config) => {
        const { printConfig = {}, data = [] } = config;
        const { dataSource = CAINIAO, traceId = '', pdfPrint } = printConfig;
        const taskID = `${new Date().getTime()}${getUUID()}`;
        try {
            EventManager.Instance.addTaskCache(taskID, traceId);
        }
        catch (e) {
            console.error(e);
        }
        if (dataSource === CAINIAO) {
            if (EventManager.Instance.supposeCloud) {
                return {
                    requestID: getUUID(),
                    version: '1.0',
                    cmd: GETPRINRTASKSTATUS,
                    task: {
                        taskID,
                        preview: printConfig.preview,
                        printer: printConfig.printer,
                        previewType: printConfig.previewType || 'pdf',
                        printType: printConfig.printType,
                        documents: data,
                    },
                    pageSession: {
                        pageName: printConfig.pageName || '',
                        pageCode: printConfig.pageCode || '',
                        pageUrl: window.location.href,
                    },
                    ...printConfig,
                };
            }
            const nextConfig = {
                ...commConfig,
                configName: printConfig.configName,
                data: {
                    requestID: getUUID(),
                    version: '1.0',
                    cmd: GETPRINRTASKSTATUS,
                    task: {
                        taskID,
                        preview: printConfig.preview,
                        printer: printConfig.printer,
                        previewType: printConfig.previewType || 'pdf',
                        documents: data,
                        printType: '',
                    },
                    pageSession: {
                        pageName: printConfig.pageName || '',
                        pageCode: printConfig.pageCode || '',
                        pageUrl: window.location.href,
                    },
                    ...printConfig,
                },
            };
            if (pdfPrint) {
                nextConfig.data.task.printType = 'dirctPrint';
            }
            return nextConfig;
        }
        if (dataSource === PDD) {
            return {
                ERPId: printConfig.ERPId,
                cmd: 'print',
                requestID: getUUID(),
                task: {
                    documents: data,
                    notifyType: ['print'],
                    preview: printConfig.preview,
                    previewType: printConfig.previewType || 'pdf',
                    printer: printConfig.printer,
                    taskID,
                },
                version: '1.0',
            };
        }
        if (dataSource === JD) {
            return {
                orderType: printConfig.preview ? 'PRE_View' : 'PRINT',
                key: taskID,
                parameters: {
                    printName: printConfig.printer,
                    ...data,
                },
            };
        }
        if (dataSource === BYTE) {
            return {
                cmd: 'print',
                requestID: getUUID(),
                version: '1.0',
                task: {
                    taskID,
                    preview: printConfig.preview,
                    printer: printConfig.printer,
                    documents: data,
                },
            };
        }
        if (dataSource === KUAISHOU) {
            return {
                cmd: 'print',
                requestID: getUUID(),
                task: {
                    documents: data,
                    preview: printConfig.preview,
                    previewType: printConfig.previewType || 'pdf',
                    printer: printConfig.printer,
                    taskID,
                },
                version: '1.0',
            };
        }
        if (dataSource === VIP) {
            return {
                actionType: 'PRINT',
                traceId: taskID,
                storeId: printConfig.storeId,
                printParamDTO: data,
                printerName: printConfig.printer || printConfig.configName || '',
            };
        }
        if (dataSource === HUAWEI) {
            const [item = {}] = data; // data即documents，华为只会有一项@阿亨，{ Cmd, requestId, version, printDataList }
            const { cmd } = item;
            return {
                ...item,
                Cmd: cmd,
            };
        }
    },
    getTaskStatus: (taskID = []) => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: GETTASKSTATUSBYTASKID,
                taskID,
            },
        };
    },
    getGlobalConfig: () => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: GETGLOBALCONFIG,
            },
        };
    },
    setGlobalConfig: (notifyOnTaskFailure = false) => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: SETGLOBALCONFIG,
                notifyOnTaskFailure,
            },
        };
    },
    getAgentInfo: () => {
        return {
            ...commConfig,
            data: {
                requestID: getUUID(),
                version: '1.0',
                cmd: GETAGENTINFO,
            },
        };
    },
    getConfigName: () => ({
        bussinessType: BUSINESSTYPE,
        messageType: CONFIGMESSAGETYPE,
    }),
    getPrintConfigNameList: () => ({
        bussinessType: BUSINESSTYPE,
        messageType: MESSAGETYPE,
        data: {
            requestID: getUUID(),
            version: '1.0',
            cmd: GETPRINTCONFIGNAMELIST,
        },
    }),
};
export { GETPRINTERS, GETPRINTERCONFIGBYPRINTERNAME, SETPRINTERCONFIG, GETPRINRTASKSTATUS, NOTIFYPRINTRESULT, GETTASKSTATUSBYTASKID, GETGLOBALCONFIG, SETGLOBALCONFIG, GETAGENTINFO, BUSINESSTYPE, MESSAGETYPE, OLDPRINTMESSAGETYPE, OLDGETCONFIGMESSAGETYPE, COMMENDCONFIG, DOLOGHOST, CONFIGMESSAGETYPE, PRINTRESULTNOTIFY, SUCCESS, FAILED, NOTIFYPRINTERROR, };
